export default __webpack_public_path__ + "static/media/about-image.abfe21ca.png";